import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setHeaderQuestion,
  setShowBack,
  setShowVerifyPassword,
  setShowResendCode,
  setVerificationCode,
  setVerificationCodeValidity,
} from "../onboardingSlice";
import InputText from "../Components/InputText";
import { ReactComponent as AlertIcon } from "assets/svg/icons/alert-circle.svg";

const ForgotPassword = () => {
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  const [symbols, setSymbols] = useState(new Array(6).fill(""));
  const inputRefs = useRef(new Array(6).fill(null));

  const dispatch = useDispatch();
  const header = "Forgot password";
  const { Email } = useSelector((state) => state.onboarding.body.form);
  const { confirmEmailForgotPassword } = useSelector((state) => state.login);

  useEffect(() => {
    if (confirmEmailForgotPassword.error) {
      setIsErrorVisible(true);
    }
  }, [confirmEmailForgotPassword]);

  useEffect(() => {
    if (inputRefs?.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  useEffect(() => {
    dispatch(setVerificationCode(symbols.join("")));
    if (symbols.includes(null) || symbols.includes("")) {
      dispatch(setVerificationCodeValidity(false));
    } else {
      dispatch(setVerificationCodeValidity(true));
    }

    return () => {
      dispatch(setVerificationCodeValidity(null));
    };
  }, [symbols, dispatch]);

  useEffect(() => {
    dispatch(setHeaderQuestion(header));
  }, [dispatch, header]);

  useEffect(() => {
    dispatch(setShowBack(true));
    dispatch(setShowResendCode(true));
    dispatch(setShowVerifyPassword(true));

    return () => {
      dispatch(setShowBack(false));
      dispatch(setShowResendCode(false));
      dispatch(setShowVerifyPassword(false));
    };
  }, [dispatch]);

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").slice(0, 6);

    setSymbols((prev) => {
      const newSymbols = pasteData.split("").map((char) => (/^\d$/.test(char) ? char : ""));
      return newSymbols.concat(new Array(6 - newSymbols.length).fill(""));
    });
  };

  const handleChange = (index, e) => {
    const i = e.target.value;

    if (/^\d{1}$/.test(i) && Number(i) && index < inputRefs.current.length) {
      setSymbols((prev) => {
        prev[index] = i;
        return [...prev];
      });

      if (index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }

    if (isErrorVisible) {
      setIsErrorVisible(false);
    }
  };

  const handleKeyDown = (index, e) => {
    if ((e.keyCode === 8 || e.keyCode === 46) && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <div className="createAccountContainer">
      <span>
        If your email exists in our system, we will send you a one time code to reset your password
      </span>
      <InputText placeholder={"Email"} label="Email" val={Email} disabled={true} focus={false} />
      <div className="boxesContainer">
        <span className="boxLabel">Secure code</span>
        <div className="boxes">
          {symbols.map((symbol, index) => {
            return (
              <React.Fragment key={index}>
                <div
                  className={`box ${
                    symbol !== "" ? "active" : symbols[index - 1] !== "" ? "current active" : null
                  }
                  ${isErrorVisible ? "invalid" : null}`}
                >
                  <input
                    ref={(ref) => (inputRefs.current[index] = ref)}
                    type="tel"
                    maxLength={1}
                    pattern="[0-9]*"
                    value={symbol}
                    onPaste={handlePaste}
                    onChange={(e) => handleChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    className={`${symbol !== "" ? "active" : null} ${
                      isErrorVisible ? "invalid" : null
                    }`}
                  />
                </div>
                {index === 2 && <span>-</span>}
              </React.Fragment>
            );
          })}
        </div>
        {isErrorVisible && (
          <div className="errorMessage">
            <AlertIcon />
            <span>{confirmEmailForgotPassword.error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
